import MagicEditor from "components/layout/MagicEditor";
import { useEffect, useRef, useState } from "react";
import { HiOutlinePencil } from "react-icons/hi2";
import useOnClickOutside from "utils/hooks/useOnClickOutside";

const LinkPreview = ({
    link,
    network,
    post = undefined,
    isEditable = false,
    onLinkEdit = undefined
}) => {

    const [ isEditing, setIsEditing ] = useState(false);
    const [ value, setValue ] = useState(link);
    const [ valueOnEdit, setValueOnEdit ] = useState(link);
    const wrapperRef = useRef();

    const onCancel = () => {
        setValue(valueOnEdit);
        setIsEditing(false);
    }

    const onConfirm = () => {
        onLinkEdit && onLinkEdit(value);
        setIsEditing(false);
    }

    useOnClickOutside(wrapperRef, () => {
        onLinkEdit && onLinkEdit(value);
        setIsEditing(false);
    }, [value]);

    useEffect(() => {
        if (isEditing == true) {
            setValueOnEdit(value);
        }
    }, [isEditing]);

    useEffect(() => {
        if (link != value) {
            setValue(link);
        }
    }, [link]);

    return (
        <div className="text-tertiary-800 dark:text-gray-50 !text-base">
            {!isEditing 
                ? <div className={`${isEditable && `group cursor-pointer`} ${(!value || !value?.trim()) && `mb-2`} inline-block`} onClick={() => isEditable && setIsEditing(true)}>
                    <span className={`inline text-sm font-semibold group-hover:bg-tertiary-100 dark:group-hover:bg-gray-900 ${(!value || !value?.trim()) && `text-tertiary-400 dark:text-gray-600 italic`}`} dangerouslySetInnerHTML={{__html: value?.trim() || value || (isEditable ? "Click here to add a link to this post..." : ``)}}></span>
                    <span><HiOutlinePencil className="text-tertiary-600 -mt-2.5 text-sm ml-1 hidden group-hover:inline" /></span>
                </div>
                : <div className="relative" ref={wrapperRef}>
                    <MagicEditor 
                        value={value}
                        setValue={setValue}
                        network={network}
                        className="!text-sm !font-semibold !p-0 w-full !pb-0 !overflow-y-hidden !bg-secondary-500 dark:!bg-gray-800"
                        footerClassName="!border-0 !px-0 !mt-4 !rounded-xl !rounded-t-xl !rounded-b-xl"
                        onCancel={onCancel}
                        onConfirm={onConfirm}
                        minHeight={10}
                        autoFocus={true}
                        post={post}
                        showOptionsBar={false}
                        placeholder="Insert a destination link..."
                        onKeyDown={(e) => { if (e.key == 'Enter') onConfirm() }}
                    />
                </div>
            }
        </div>
    );
}

export default LinkPreview;